










import {
  defineComponent,
} from '@vue/composition-api';

import CommonFormWithProductCreator from '@/components/Product/CommonFormWithProductCreator.vue';

const CreateProduct = defineComponent({
  components: {
    CommonFormWithProductCreator,
  },
});

export default CreateProduct;
